import React from 'react'

import { ThemeEnum } from '@hooks/contexts/ThemeContext/interface'
import { useTheme } from '@hooks/contexts/ThemeContext/ThemeContext'
import { ThemeButtonProps } from './interface'

export function withThemeButton(Component: React.FC<ThemeButtonProps>) {
  function WithThemeButton() {
    const {
      theme,
      fontSize,
      lineHeight,
      fontFamily,
      updateTheme,
      updateFontSize,
      updateLineHeight,
      updateFontFamily,
    } = useTheme()

    function handleThemeChange(value: ThemeEnum) {
      updateTheme(value)
    }

    const componentProps = {
      theme,
      fontSize,
      lineHeight,
      fontFamily,
      handleThemeChange,
      updateFontSize,
      updateLineHeight,
      updateFontFamily,
    }

    return <Component {...componentProps} />
  }

  return WithThemeButton
}
